import axios from "axios";

/**
 * The current site's cloud-SMS allowance. Any active member of the site may read it.
 *
 * Polled from the top navigation bar, so a failure must not throw the user out to the error screen:
 * the meter simply stays hidden until the next poll succeeds. That includes a 404, which is what a
 * stack whose backend has not yet been deployed with this endpoint answers — without the opt-out every
 * page load on that stack would land on the address-is-wrong page.
 */
export const apiSiteSmsAllowanceGet = async (siteId) => {
	const result = await axios({
		method: "get",
		url: "v2/Site/SmsAllowance",
		params: { siteId },
		headers: {
			backgroundTaskAllowFail: true,
			allowNotFound: true,
		},
	});

	return result.data;
};
